export const NAME_REGEX = /^[A-Za-z ]+$/;
export const PINCODE_REGEX = /^\d{6}$/;
// Changed regex to allow only 10 digits starting with 6-9
export const MOBILE_REGEX = /^[6-9]\d{9}$/;
export const EPIN_REGEX = /^\d{6}$/;